import { useTheme } from '@emotion/react'
import { Done } from 'emotion-icons/material'
import * as React from 'react'
import Brandy from '../Brandy'
import ListItem from '../List/ListItem'
import Typography from '../Typography'
import * as Styled from './Price.styles'

/* eslint-disable react/no-danger */
const Price = ({
  amount,
  large = false,
  condensed = false,
  before = null,
  duration = '/mo',
  children = null,
  nutrition = null,
  bullets = null,
  showFeaturedBullets = null,
  inPackageCard = false,
  variant = null,
  priceOld = null,
  price = null, // brand data
  priceDuration = 'mo', // brand data
  priceIntro = null, // brand data
  priceOutro = null, // brand data
  ...props
}) => {
  const { components } = useTheme()
  const pricing = price || amount
  const pricingDuration = `/${priceDuration}` || duration

  // if nutrition is a string (from brandy), render it as HTML since they use tags, otherwise render it as whatever
  const nutritionComponent =
    typeof nutrition === 'string' && nutrition !== '' ? (
      <Typography
        variant="legal"
        className="nutrition"
        dangerouslySetInnerHTML={{
          __html: `${nutrition}`.trim(),
        }}
      />
    ) : (
      nutrition && <span className="nutrition">{nutrition}</span>
    )

  return (
    <Styled.PriceWrapper>
      <Styled.Before className="before" inPackageCard={inPackageCard}>
        {priceIntro || 'Starting at'}
      </Styled.Before>
      <Styled.Price
        className="leshen-price"
        condensed={condensed}
        large={large}
        aria-label={`${before || ''} $${amount} per ${pricingDuration}`}
        variant={variant}
        durationUnderPrice={pricingDuration.length > 6 && inPackageCard}
        longDuration={pricingDuration.length > 6}
        {...props}
        inPackageCard={inPackageCard}
      >
        {priceOld && (
          <Typography
            className="price-old"
            variant="body"
            strikethrough
            customWeight="700"
          >
            ${priceOld}
          </Typography>
        )}
        <Styled.PriceWrapper className="leshen-price-wrapper package-default">
          <Styled.AmountWrapper
            inPackageCard={inPackageCard}
            className="leshen-price-amount-wrapper"
          >
            <Styled.SymbolAndDollarAmount inPackageCard={inPackageCard}>
              <Styled.Currency
                className="leshen-price-currency"
                inPackageCard={inPackageCard}
              >
                $
              </Styled.Currency>
            </Styled.SymbolAndDollarAmount>
            <Styled.DollarAmount
              className="leshen-price-dollar"
              inPackageCard={inPackageCard}
            >
              {pricing?.split('.')?.[0]}
            </Styled.DollarAmount>
            {/* Add the cents and duration in the same wrapper */}
            {/* eslint-disable-next-line no-nested-ternary */}
            {components?.Price?.duration?.position === 'underCents' ? (
              <Styled.CentsAndDuration inPackageCard={inPackageCard}>
                <Styled.ChangeAmount
                  inPackageCard={inPackageCard}
                  className="leshen-price-change"
                >
                  <span>
                    {!components?.Price?.noDecimal &&
                      pricing?.split('.')?.[1]?.length > 0 &&
                      '.'}
                    <span>{pricing?.split('.')?.[1]}</span>
                  </span>
                  <Styled.Divider inPackageCard={inPackageCard} />
                </Styled.ChangeAmount>
                <Styled.Duration
                  className="leshen-price-duration"
                  inPackageCard={inPackageCard}
                >
                  <span
                    className="duration-html"
                    dangerouslySetInnerHTML={{
                      __html: `${pricingDuration}`.trim(),
                    }}
                  />
                </Styled.Duration>
              </Styled.CentsAndDuration>
            ) : components?.Price?.duration?.position === 'underPrice' ? (
              <>
                {pricing[1] && pricing.split('.')[1]?.length > 0 && (
                  <Styled.ChangeAmount
                    className="leshen-price-change"
                    inPackageCard={inPackageCard}
                  >
                    {!components?.Price?.noDecimal &&
                      pricing.split('.')[1]?.length > 0 &&
                      '.'}
                    <span>{pricing?.split('.')?.[1]}</span>
                  </Styled.ChangeAmount>
                )}
              </>
            ) : (
              <>
                {pricing?.[1] && pricing.split('.')[1]?.length > 0 && (
                  <Styled.ChangeAmount
                    inPackageCard={inPackageCard}
                    className="leshen-price-change"
                  >
                    {!components?.Price?.noDecimal &&
                      pricing.split('.')[1]?.length > 0 &&
                      '.'}
                    <span>{pricing?.split('.')?.[1]}</span>
                  </Styled.ChangeAmount>
                )}
                <Styled.Duration
                  className="leshen-price-duration"
                  inPackageCard={inPackageCard}
                >
                  <span
                    className="duration-html"
                    dangerouslySetInnerHTML={{
                      __html: `${pricingDuration}`.trim(),
                    }}
                  />
                </Styled.Duration>
              </>
            )}
          </Styled.AmountWrapper>
          {components?.Price?.duration?.position === 'underPrice' && (
            <Styled.Duration
              className="leshen-price-duration"
              inPackageCard={inPackageCard}
            >
              <span
                className="duration-html"
                dangerouslySetInnerHTML={{
                  __html: `${pricingDuration}`.trim(),
                }}
              />
            </Styled.Duration>
          )}
          <Styled.DisclaimersWrapper className="leshen-price-disclaimers-wrapper">
            <>
              {props?.disclaimer && (
                <Styled.Disclaimer
                  symbol={props?.disclaimer?.symbol}
                  text={props?.disclaimer?.text}
                  variant="legal"
                  styles={variant}
                  className="leshen-price-duration-disclaimer"
                />
              )}
              {children && <span className="modal">{children}</span>}
              {nutritionComponent && nutritionComponent}
              {priceOutro && priceOutro}
            </>
          </Styled.DisclaimersWrapper>
        </Styled.PriceWrapper>
      </Styled.Price>
      {bullets && showFeaturedBullets && (
        <Styled.Bullets className="leshen-price-list">
          {bullets?.map((bullet) => (
            <ListItem
              className="leshen-price-list-item"
              key={bullet?.text}
              icon={<Done />}
            >
              <Brandy text={bullet?.text} variant="body" />
              {bullet.disclaimer && (
                <Brandy
                  symbol={bullet?.disclaimer.symbol}
                  text={bullet?.disclaimer.text}
                  variant="legal"
                />
              )}
            </ListItem>
          ))}
        </Styled.Bullets>
      )}
    </Styled.PriceWrapper>
  )
}

/* eslint-enable react/no-danger */
export default Price
